export default function StatusPill({ text, type = "warning" }) {
  const styles =
    type === "success"
      ? "bg-[#ECFDF5] text-[#059669]"
      : "bg-[#FFF7ED] text-[#D97706]";

  return (
    <span className={`inline-block px-3 py-1 rounded-full text-xs ${styles}`}>
      {text}
    </span>
  );
}
